import React, { useState } from 'react';

function findNomeByCnpj(cnpjDesejado) {
  const cnpjs = JSON.parse(localStorage.getItem('cnpjs')) || [];
  const found = cnpjs.find(item => item.cnpj === cnpjDesejado);
  return found ? found.nome : 'Nome não encontrado';
}

const CnpjSelector = ({ cnpjs, onSelect }) => {
  const [selectedCnpj, setSelectedCnpj] = useState('');

  const handleCnpjSelect = (cnpjObj) => {
    setSelectedCnpj(cnpjObj.cnpj);
    onSelect(cnpjObj.cnpj);
    localStorage.setItem('cnpj-token', cnpjObj.cnpj);
    localStorage.setItem('nome-token', findNomeByCnpj(cnpjObj.cnpj));
  };

  function formatCnpj(cnpj) {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return (
    <ul className="cnpj-selector-list">
      {cnpjs.map((cnpjObject) => (
        <li key={cnpjObject.cnpj}>
          <button
            className="cnpj-btn"
            onClick={() => handleCnpjSelect(cnpjObject)}
            style={selectedCnpj === cnpjObject.cnpj ? { borderColor: 'var(--accent-green)', color: 'var(--accent-green)' } : {}}
          >
            <strong>{formatCnpj(cnpjObject.cnpj)}</strong>
            <span style={{ marginLeft: 8, color: 'var(--text-secondary)' }}>— {cnpjObject.nome}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default CnpjSelector;
